export const PageTitles = {
  purchase: 'Get Your Chef Ami Gift Purchase',
  payment: 'Checkout - Chef Ami',
  thankYou: 'Thank You - Chef Ami',
  notFound: 'Error - Chef Ami',
} as const;

export const SiteStorage = {
  GIFTCARDDETAILS: 'gift_card_details',
} as const;

/**
 * Gift card delivery type.
 * Determines whether a physical card is shipped or an e-gift email is sent.
 */
export enum GiftCardType {
  PHYSICAL = 0,
  EGIFT = 1,
}

/**
 * Gift card page image paths.
 * These are served from the `public/img/` folder (available at `/img/` at runtime).
 */
export const ImagePaths = {
  GIFT_CARD_BANNER: '/img/GIFT_CARD_BANNER.jpg',
  BOX_BACKGROUND_IMAGE: '/img/card_background.png',
  BOX_LOGO: '/img/card_logo.png',
} as const;

/**
 * Custom amount input boundaries.
 */
export const CustomAmount = {
  MIN: 25,
  MAX: 500,
} as const;
